var _MainCategoryCardSkel;
import { CourseCardSkeleton, GridScroll, MainCategoryCardSkeleton } from "../../../../../components";
import { jsx as _jsx } from "react/jsx-runtime";
var MainCategoriesContentSkeleton = function MainCategoriesContentSkeleton(_ref) {
  var className = _ref.className;
  var renderCard = function renderCard(_, index) {
    return /*#__PURE__*/_jsx(CourseCardSkeleton, {}, index);
  };
  return /*#__PURE__*/_jsx(GridScroll, {
    items: Array.from({
      length: 3
    }).map(renderCard),
    className: className,
    children: _MainCategoryCardSkel || (_MainCategoryCardSkel = /*#__PURE__*/_jsx(MainCategoryCardSkeleton, {
      className: "tw-h-full"
    }))
  });
};
export default MainCategoriesContentSkeleton;